// @flow
import * as React from "react"
import { FilterToggleWrap } from "./styled"

type Props = {|
  value: any,
  onClick: Function,
  formatter: Function,
  selected: boolean,
|}

const FilterToggle = ({ value, onClick, formatter, selected }: Props) => (
    <FilterToggleWrap selected={selected} onClick={() => onClick(value)}>
      {formatter(value)}
    </FilterToggleWrap>
  )

export default FilterToggle



// WEBPACK FOOTER //
// ./src/components/ProductCategorySelector/FilterToggle/index.js